import React from 'react';
import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Home from "./pages/home/Home";
import Layout from "./Layout";
import PageNotFound from "./pages/page-not-found/PageNotFound";
import User from "./pages/user/User";
import UserMessages from "./pages/user-messages/UserMessages";
import Booking from "./pages/booking/Booking";
import Customer from "./pages/customer/Customer";
import Subscription from "./pages/subscription/Subscription";
import Invoice from "./pages/invoice/Invoice";
import Provider from "./pages/provider/Provider";
import Expense from "./pages/expense/Expense";

function AppRouter() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Layout/>}>
                    <Route index element={<Home/>}/>
                    <Route path="customers" element={<Customer/>}/>
                    <Route path="bookings" element={<Booking/>}/>
                    <Route path="subscriptions" element={<Subscription/>}/>
                    <Route path="invoices" element={<Invoice/>}/>
                    <Route path="expenses" element={<Expense/>}/>
                    <Route path="provider" element={<Provider/>}/>
                    <Route path="user" element={<User/>}/>
                    <Route path="user/messages" element={<UserMessages/>}/>
                    <Route path="*" element={<PageNotFound/>}/>
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default AppRouter;
